<template>
  <content-layout class="modal">
    <div class="result">
      <div class="top">
        <span class="order">Счет № {{ order.id }}</span>
        <div class="title">Оплата прошла успешно!</div>
        <div class="delivery-info">
          <div class="delivery-info-item">
            <div class="label">Адресат</div>
            <div class="value">{{ recipientName }}</div>
          </div>
          <div v-if="!isSelfdelivery" class="delivery-info-item">
            <div class="label">По адресу</div>
            <div class="value">{{ address }}</div>
          </div>
          <div v-if="!isSelfdelivery" class="delivery-info-item">
            <div class="label">Дата</div>
            <div class="value">{{ formattedDate }}</div>
          </div>
          <div v-if="isSelfdelivery" class="delivery-info-item">
            Доставка самовывозом
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="section">
          <template v-for="(item, index) in order.items">
            <div class="order-row" :key="`card_${index}`">
              <p>Подарочная карта {{ item.amount | costFormat }}</p>
              <p>х{{ item.qty }}</p>
              <p>{{ item.amount * item.qty | costFormat }} руб.</p>
            </div>
          </template>
          <div class="order-row" v-if="!isSelfdelivery">
            <p>Доставка</p>
            <p>{{ total >= 150 ? 0 : order.delivery.cost | costFormat}} руб.</p>
          </div>
          <div class="order-row total">
            <p class="sum-text">Итоговая сумма</p>
            <p>{{ order.total | costFormat }} руб.</p>
          </div>
        </div>
        <div class="section">
          <p class="reminder">
            Письмо с подробной информацией по заказу отправлено вам на почту.
          </p>
          <div class="thx">Спасибо за заказ!</div>
        </div>
      </div>
      <router-link :to="{ name: 'Index' }" class="go-back"></router-link>
      <!-- <a @click="goHome" class="go-back"></a> -->
    </div>
  </content-layout>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

import ContentLayout from '@/components/ContentLayout.vue'
import { apiUrl } from '@/config.js'

moment.locale('ru')

export default {
  name: 'real-result',
  data () {
    return {
      orderId: '',
      lowDeliveryLimit: 0,
      order: {
        id: '',
        buyer: {},
        delivery: {},
        items: []
      },
      city: {},
      total: 0
    }
  },
  components: {
    ContentLayout: ContentLayout
  },
  computed: {
    recipientName () {
      return this.order.delivery?.toBuyer ? this.order.buyer.name : this.order.recipient.name
    },
    address () {
      return `${this.order.delivery.address}, ${this.order.delivery.addressApartment}`
    },
    isSelfdelivery () {
      return this.order.delivery.date === ''
    },
    formattedDate () {
      return moment(String(this.order.delivery.date)).format('DD MMMM YYYY')
    }
  },
  created () {
    this.$localStorage.set('result', 'success')
    this.order = this.$localStorage.get('order')
    if (!this.order) {
      this.$router.push({ name: 'ModalError' })
    }
    axios.get(`${apiUrl}/cards`)
      .then(({ data }) => {
        this.order = this.$localStorage.get('order')
        this.order.id = this.$localStorage.get('orderId')
        this.city = data.cities.find(city => city.id === this.order.cityId)
        this.total = this.order.items.reduce((acc, el) => {
          return acc + el.amount
        }, 0)
        this.$localStorage.remove('order')
        this.$localStorage.remove('orderId')
      })
  },
  beforeDestroy () {
    this.$localStorage.remove('result')
  }
}
</script>

<style scoped>
  .order-row {
    display: flex;
    justify-content: space-between;
  }
  .total {
    font-weight: 700;
    font-size: 18px;
  }
  .result {
    position: relative;
    font: 500 14px/1 Museo, sans-serif;
    width: 480px;
  }
  .top {
    padding: 0 33px 25px;
    border-bottom: 1px solid rgba(139, 139, 139, .5);
  }
  .go-back {
    position: absolute;
    top: 0;
    right: 20px;
    width: 20px;
    height: 20px;
    text-indent: 100%;
    white-space: nowrap;
    overflow: hidden;
    padding: 5px;
    opacity: .4;
  }
  .go-back:hover {
    opacity: 1;
  }
  .go-back::before,
  .go-back::after {
    content: '';
    display: block;
    background: #000;
    height: 3px;
    width: 25px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    transform-origin: center;
  }
  .go-back::after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }

  .order {
    display: inline-block;
    padding: 8px 20px 6px;
    margin-bottom: 20px;
    border-radius: 4px;
    background-color: #bc9665;
    color: #fff;
    text-transform: uppercase;
  }
  .title {
    font: 700 48px/1 Bebas, sans-serif;
    margin-bottom: 10px;
  }
  .delivery-info-item {
    margin-bottom: 12px;
  }
  .delivery-info-item:last-child {
    margin-bottom: 0;
  }
  .label {
    font-size: 10px;
    font-weight: 700;
    color: #9d9c9a;
    text-transform: uppercase;
    margin-bottom: 5px;
  }
  .value {
    font-size: 16px;
  }
  .bottom {
    background-color: #ededed;
    box-shadow: inset 0 4px 12px 0 rgba(0, 0, 0, 0.05);
  }
  .section {
    position: relative;
    padding: 28px 33px 20px;
    width: 100%;
  }
  .section::after {
    content: '';
    display: block;
    height: 1px;
    width: 100%;
    background: linear-gradient(to right, #d5d5d4 33%, transparent 33%, transparent 66%, #d5d5d4 66%) repeat-x;
    background-size: 12px 1px;
    position: absolute;
    top: 100%;
    left: 0;
  }
  .section:last-child {
    padding: 25px 33px;
  }
  .section:last-child::after {
    display: none;
  }
  .tfoot .td {
    padding-top: 20px;
  }
  .sum-text {
    text-transform: uppercase;
  }
  .reminder {
    font-size: 13px;
    color: #9d9c9a;
    text-align: center;
    margin: 0 0 20px 0;
  }
  .thx {
    font-family: Bebas;
    font-size: 26px;
    font-weight: 700;
    text-align: center;
    text-transform: uppercase;
  }

  /*=============================================>>>>>
  = Mobile =
  ===============================================>>>>>*/

  @media screen and (max-width: 1023px) {

    .result {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
    .top {
      background-color: #f6f6f7;
      border: none;
      padding: 0 20px 25px;
    }

    .go-back {
      box-sizing: content-box;
      background-color: #fff;
      box-shadow: 2.8px 2.8px 14px 0 rgba(0, 0, 0, 0.15);
      border-radius: 50%;
      overflow: hidden;
      padding: 17px;
      position: fixed;
      z-index: 2;
      top: 12px;
      right: 8px;
      opacity: .7;
    }

    .go-back::before,
    .go-back::after {
      width: 20px;
    }
    .order {
      padding: 9px 20px 7px;
      margin-bottom: 15px;
    }
    .title {
      font-size: 36px;
      margin-bottom: 20px;
      padding-right: 65px;
    }
    .label {
      font-size: 12px;
    }
    .value {
      font-size: 18px;
    }
    .bottom {
      flex: 1;
    }
    .section {
      padding: 28px 20px 20px;
      max-width: 60%;
    }
    .section:last-child {
      padding: 25px 20px;
    }
  }

  @media screen and (max-width: 600px) {
    .section {
      max-width: 90%;
    }
  }

  @media screen and (max-width: 400px) {
    .section {
      max-width: 100%;
    }
  }
</style>
